import * as StakeholderStoreActions from './stakeholder.actions';
import * as StakeholderStoreSelectors from './stakeholder.selector';
import * as StakeholderStoreReducer from './stakeholder.reducer';


export { StakeholderStoreActions, StakeholderStoreSelectors, StakeholderStoreReducer };
